import { Modal, Alert, Button } from "react-bootstrap";
import './CodeSearch.css';

const CancerWarningPanel = ({ show, cancerCodeWarningsList, clusterCodeWarningsErrorList= [], onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg" backdropClassName="cancer-backdrop"
  contentClassName="cancer-modal">
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">
          ⚠️ Cancer cases identified. Verification is required.
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "350px", overflowY: "auto" }}>
        <Alert variant="warning" className="mb-2">
  
  {/* Info Warnings */}
  {cancerCodeWarningsList?.info_warnings?.map((w, index) => (
    <div key={`info-${index}`}>{w}</div>
  ))}

  {/* Cancer Codes */}
  {cancerCodeWarningsList?.cancer_codes?.length > 0 && (
    <ul style={{ marginBottom: 0, paddingLeft: "20px" }}>
      {cancerCodeWarningsList.cancer_codes.map((code, index) => (
        <li key={`code-${index}`}>{code}</li>
      ))}
    </ul>
  )}

</Alert>
        
        
        {/* {clusterCodeWarningsErrorList.map((w, index) => (
          <Alert key={index} variant="danger" className="mb-2">
            {w}
          </Alert>
        ))} */}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancerWarningPanel;
